import { createContext, useState, useEffect, useContext } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";

import Modal from '@/components/Modal'
import { useQuery } from "@/hooks/useQuery";
import { requireAuthModals } from '@/modalRoutes'
import { AuthContext } from "./AuthContext";

const ModalContext = createContext()

const ModalProvider = ({ children }) => {
  const { auth } = useContext(AuthContext)
  const [modal, setModal] = useState(null)
  const router = useNavigate()
  const query = useQuery()

  const closeModal = () => {
    setModal(null)
    router(window.location.pathname)
  }

  useEffect(() => {
    const modal = query.get('modal')
    if (modal) {
      setModal(null)
      if (requireAuthModals.includes(modal) && (!auth.isLoaded || auth.isEmpty)) {
        setModal('auth')
      } else {
        setModal(modal)
      }
    } else {
      setModal(null)
    }
  }, [query])

  return (<ModalContext.Provider value={{
    modal,
    setModal,
    closeModal
  }}>
    {children}
    <Modal />
  </ModalContext.Provider>)
}

export { ModalProvider, ModalContext }